export function vues(){	
    let faq = {
		data: function () {
			return {
				flag: false
			}
		},
		methods: {
			toggle : function(){
				this.flag = !this.flag;
			}
		},
		props: ['question' , 'answer'],
		template: 
		`<dl :class="{ active: flag }">
            <dt v-html="question" @click="toggle"></dt>
            <dd v-show="flag" v-html="answer"></dd>
        </dl>`
	};
	
	const v = new Vue({
		el: '#site-wrapper',
		data: {
            sitename: '行政書士 美保雅子事務所',
			contact_flag: true,
			send_flag: false,
            entry: {
                company: '',
                name: '',
                email: '',
                tel: '',
                yubin: '',
                ken: '',
                city: '',
                build: '',
                context: '',
            }
		},
		methods: {
			validate: function(){
                this.contact_flag = true;
				if(!this.entry.email.match(/^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/)){
					this.contact_flag = false;
                }else if(this.entry.name == '' | this.entry.email == ''){
					this.contact_flag = false;
                }
                if(this.contact_flag){
                    this.send_flag = true;
                }
			},
			mailsend: function(){
                if(this.send_flag){
                    const post_url = '/mail/post.php';
                    const $_this = this;
                    axios.post(post_url , $_this.entry)
                    .then(response => {
                        if(response.data == 'success'){
                            location.href = "/send/";
                        }
                    }).catch(error => {
                        console.log(error);
                    });
                }else{
                    this.contact_flag = false;
                }
			},
		},
		components: {
			'faq' : faq
		}
	});
	
	const vh = new Vue({
		el: '#site-header',
		data: {
			nav: false,
		},
	});
}